export default "__VITE_ASSET__BRXOAS5x__"